import React, { Component } from 'react';
import { ScrollView, View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import {
  get as _get,
  includes as _includes,
  isArray as _isArray,
  isArray,
  isEqual as _isEqual,
} from 'lodash';
import PropTypes from 'prop-types';

import {
  SectionHeader,
  FilterBar,
  ErrorScreen,
  VFText,
} from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import AddOnsList from '../../Components/AddOnsList';
import AddonsShopLoading from '../AddOnsShopLoading';

import styles from './AddOnsShop.Styles';

class AddOnsShop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      addOns: [],
      selectedCategories: [],
    };
  }
  componentDidMount() {
    this.formattingAddOns();
  }
  componentDidUpdate(prevProps) {
    if (!_isEqual(prevProps.addOnsData, this.props.addOnsData)) {
      this.formattingAddOns();
      this.handleFilterAddons(this.state.selectedCategories);
    }
  }
  getAddOnsListFromCategories = items => {
    let addOnsList = [];
    let categoriesList = [];
    items.forEach(item => {
      const addOns = _get(item, 'addOns', []);
      if (addOns.length && this.isValidCategory(item)) {
        categoriesList = [...categoriesList, item];
        addOnsList = [...addOnsList, ...addOns];
      }
    });
    return [addOnsList, categoriesList];
  };
  formattingAddOns = () => {
    const { addOnsData, withCategories } = this.props;
    if (!withCategories) {
      this.setState({ addOns: _isArray(addOnsData) ? addOnsData : [] });
    } else {
      const [addOnsList, categoriesList] = this.getAddOnsListFromCategories(addOnsData);
      this.setState({
        categories: categoriesList,
        addOns: addOnsList,
      });
    }
  };
  isValidCategory = category => {
    return category.id && category.name && category.addOns && isArray(category.addOns);
  };
  setSelectedCategories = categoryId => {
    const { selectedCategories } = this.state;
    // See all
    // empty the selectedCategories
    if (!categoryId) {
      this.setState({ selectedCategories: [] }, () => {
        this.handleFilterAddons();
      });
      return;
    }
    // When press on a catagory that is not included in the filter
    // add it to the selectedCategories
    if (!_includes(selectedCategories, categoryId)) {
      this.setState({ selectedCategories: [...this.state.selectedCategories, categoryId] }, () => {
        this.handleFilterAddons(categoryId);
      });
    } else {
      // When press on a catagory that is included in the filter
      // remove it from the selectedCategories
      this.setState(
        {
          selectedCategories: [...selectedCategories.filter(c => c !== categoryId)],
        },
        () => {
          this.handleFilterAddons(categoryId);
        },
      );
    }
  };
  handleFilterAddons = categoryId => {
    const { selectedCategories } = this.state;
    const { addOnsData } = this.props;
    let filteredAddons = [];
    if (categoryId && selectedCategories.length) {
      const filteredCategories = addOnsData.filter(item => {
        return _includes(selectedCategories, item.id);
      });
      const [addOnsList] = this.getAddOnsListFromCategories(filteredCategories);
      filteredAddons = addOnsList;
    } else {
      const [addOnsList] = this.getAddOnsListFromCategories(addOnsData);
      filteredAddons = addOnsList;
    }
    this.setState({ addOns: filteredAddons });
  };
  render() {
    const {
      theme,
      titleStyle,
      subTitleStyle,
      withCategories,
      images,
      withTray,
      onItemPress,
      isLoading,
      isError,
      errorText,
      errorIconName,
      tryAgainIconName,
      onTryAgainPress,
      withDivider,
      groupAddons,
    } = this.props;
    const { categories, addOns } = this.state;
    const recurringAddOns = [];
    const nonRecurringAddOns = [];
    if (groupAddons) {
      for (const addon in addOns) {
        if (addOns[addon].digitalProductOfferingPrice[0]?.priceType === 'recurring') {
          recurringAddOns.push(addOns[addon]);
        } else {
          nonRecurringAddOns.push(addOns[addon]);
        }
      }
    }

    return isLoading ? (
      <AddonsShopLoading />
    ) : (
      <ScrollView contentContainerStyle={[withTray && styles.scrollViewContentContainerWithTray]}>
        <SectionHeader
          style={styles.sectionHeader}
          theme={theme}
          title="shop_addons_title"
          subtitle={!isError && 'shop_addons_subtitle'}
          titleStyle={titleStyle}
          subtitleStyle={subTitleStyle}
          titleAccessbilityLabel={'Shop Add-ons title'}
        />
        {withCategories && !isError && (
          <FilterBar
            setSelectedCategories={this.setSelectedCategories.bind(this)}
            selectedCategories={this.state.selectedCategories}
            filterData={categories}
          />
        )}
        {isError ? (
          <ErrorScreen
            text={errorText}
            images={images}
            iconName={errorIconName}
            iconButtonName={tryAgainIconName}
            onPress={onTryAgainPress}
            backgroundStyle={styles.errorContainer}
            iconStyle={styles.errorIcon}
          />
        ) : (
          withDivider && (
            <View style={styles.dividerContainer}>
              <View style={styles.divider(theme)} />
            </View>
          )
        )}

        <View style={styles.addOnsListContainer}>
          {!groupAddons && <AddOnsList data={addOns} images={images} onItemPress={onItemPress} />}
          {groupAddons && (
            <>
              {recurringAddOns.length > 0 && (
                <>
                  <VFText
                    i18nKey={'recurring_addons_text'}
                    style={styles.headerDescription(theme)}
                  />
                  <AddOnsList data={recurringAddOns} images={images} onItemPress={onItemPress} />
                </>
              )}
              {nonRecurringAddOns.length > 0 && (
                <>
                  <VFText
                    i18nKey={'nonrecurring_addons_text'}
                    style={styles.headerDescription(theme)}
                  />
                  <AddOnsList data={nonRecurringAddOns} images={images} onItemPress={onItemPress} />
                </>
              )}
              {recurringAddOns.length === 0 && nonRecurringAddOns.length === 0 && (
                <>
                  <VFText
                    i18nKey={'filter_addons_not_available_text'}
                    style={styles.noAddonsText}
                  />
                </>
              )}
            </>
          )}
        </View>
      </ScrollView>
    );
  }
}

AddOnsShop.defaultProps = {
  theme: LightThemeColors,
  withDivider: true,
  groupAddons: false,
};

AddOnsShop.propTypes = {
  withCategories: PropTypes.bool,
  withTray: PropTypes.bool,
  addOnsData: PropTypes.array,
  isLoading: PropTypes.bool,
  images: PropTypes.object,
  titleStyle: ViewPropTypes.style,
  subTitleStyle: ViewPropTypes.style,
  onItemPress: PropTypes.func,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  isError: PropTypes.bool,
  errorText: PropTypes.string,
  errorIconName: PropTypes.string,
  tryAgainIconName: PropTypes.string,
  onTryAgainPress: PropTypes.func,
  withDivider: PropTypes.bool,
  groupAddons: PropTypes.bool,
};

export default withTheme(AddOnsShop);
